import 'css-chunksrc/client/pages/projectPage/synthesisPage/monitoringLoader/styles.scss';export default {
  "progressions": "_progressions_mvcfv_1",
  "tasksProgression": "_tasksProgression_mvcfv_10",
  "milestones": "_milestones_mvcfv_14"
};